import { render, staticRenderFns } from "./deliveryReceiptProductList.vue?vue&type=template&id=62cd322c&scoped=true"
import script from "./deliveryReceiptProductList.vue?vue&type=script&lang=js"
export * from "./deliveryReceiptProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cd322c",
  null
  
)

export default component.exports